// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"loginLoader_loading_container__TRYUz","dot_windmill":"loginLoader_dot_windmill__2PnfP","dotWindmill":"loginLoader_dotWindmill__nIpSA"};